import { useEffect, useState } from "react";
import { useReducedMotion } from "framer-motion";
import { isTouchDevice } from "@/lib/motionSystem";

export default function useMotionPreferences() {
  const reduced = useReducedMotion();
  const [touch, setTouch] = useState(false);

  useEffect(() => {
    setTouch(isTouchDevice());
  }, []);

  return {
    prefersReducedMotion: Boolean(reduced),
    isTouch: touch,
    allowDecorativeEffects: !reduced && !touch,
  };
}
